import React from "react"
import {StockDocumentAction} from "../../state/inventory/stockdocument/actions"
import {useDispatch} from "react-redux"
import Icon from "../icon/icon.component"
import {FormattedMessage} from "react-intl"

export const DropdownItemDelete = () => {
    const dispatch = useDispatch()

    return {
        children: <>
            <Icon value={"trash"} className={"mr-1"}/>
            <FormattedMessage
                id="inventory_components_footer_delete"
                defaultMessage="Delete"/>
        </>,
        onClickCallback: () => {
            dispatch(StockDocumentAction.delete())
        },
        className: "btn-outline-danger"
    }
}


// WEBPACK FOOTER //
// ./src/common/dropdown/DropdownItemDelete.tsx